// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DateFns from "lumi-rescript/lib/es6/src/DateFns.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Locale$LumiI18n from "./Locale.res.js";
import Format from "date-fns/format";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import FormatDistance from "date-fns/formatDistance";
import FormatDistanceStrict from "date-fns/formatDistanceStrict";

function useContext() {
  return Locale$LumiI18n.toDateFnsLocale(Locale$LumiI18n.useContext());
}

let DateFnsLocale = {
  useContext: useContext
};

function DateTime$Format(props) {
  let locale = Locale$LumiI18n.toDateFnsLocale(Locale$LumiI18n.useContext());
  return Format(props.date, props.format, {
    locale: Primitive_option.some(locale),
    weekStartsOn: props.weekStartsOn,
    firstWeekContainsDate: props.firstWeekContainsDate,
    useAdditionalWeekYearTokens: props.useAdditionalWeekYearTokens,
    useAdditionalDayOfYearTokens: props.useAdditionalDayOfYearTokens
  });
}

let Format$1 = {
  make: DateTime$Format
};

function DateTime$DateOnly(props) {
  return JsxRuntime.jsx(DateTime$Format, {
    date: props.date,
    format: DateFns.Formats.dateOnly
  });
}

let DateOnly = {
  make: DateTime$DateOnly
};

function DateTime$Short(props) {
  return JsxRuntime.jsx(DateTime$Format, {
    date: props.date,
    format: DateFns.Formats.short
  });
}

let Short = {
  make: DateTime$Short
};

function DateTime$Long(props) {
  return JsxRuntime.jsx(DateTime$Format, {
    date: props.date,
    format: DateFns.Formats.long
  });
}

let Long = {
  make: DateTime$Long
};

function DateTime$Full(props) {
  return JsxRuntime.jsx(DateTime$Format, {
    date: props.date,
    format: DateFns.Formats.full
  });
}

let Full = {
  make: DateTime$Full
};

function DateTime$DistanceToNow(props) {
  let locale = Locale$LumiI18n.toDateFnsLocale(Locale$LumiI18n.useContext());
  let now = LumiReact.CurrentTime.useCurrentTime();
  return FormatDistance(props.date, now, {
    includeSeconds: props.includeSeconds,
    addSuffix: props.addSuffix,
    locale: Primitive_option.some(locale)
  });
}

let DistanceToNow = {
  make: DateTime$DistanceToNow
};

function DateTime$Distance(props) {
  let locale = Locale$LumiI18n.toDateFnsLocale(Locale$LumiI18n.useContext());
  return FormatDistance(props.date, props.baseDate, {
    includeSeconds: props.includeSeconds,
    addSuffix: props.addSuffix,
    locale: Primitive_option.some(locale)
  });
}

let Distance = {
  make: DateTime$Distance
};

function DateTime$DistanceStrict(props) {
  let locale = Locale$LumiI18n.toDateFnsLocale(Locale$LumiI18n.useContext());
  return FormatDistanceStrict(props.date, props.baseDate, {
    addSuffix: props.addSuffix,
    unit: props.unit,
    roundingMethod: props.roundingMethod,
    locale: Primitive_option.some(locale)
  });
}

let DistanceStrict = {
  make: DateTime$DistanceStrict
};

export {
  DateFnsLocale,
  Format$1 as Format,
  DateOnly,
  Short,
  Long,
  Full,
  DistanceToNow,
  Distance,
  DistanceStrict,
}
/* LumiReact Not a pure module */
